/**
 * Shared motion timings (ms) — keep CSS / JS / tests aligned.
 * Prefer short, tactile feedback over perpetual animation.
 */
export const MOTION = {
  pressMs: 140,
  pressScale: 0.97,
  sleevePressMs: 180,
  foilFlashMs: 420,
  binderSnapMs: 520,
  celebrationMs: 2200,
  // The first-card moment carries more to read than the trade-completion one
  // (headline, subhead, two CTAs) and lands while the user is still orienting,
  // so it holds longer. It stays dismissible — this is a ceiling, not a wait.
  firstCardHoldMs: 6000,
  radarPulseMs: 1600,
  sheetSlideMs: 250,
  tabCrossfadeMs: 200,

  // ── Visual-polish pass (map + celebrations) ──────────────────────────────
  // Radial particle burst. Long enough for the eye to follow a spark outward,
  // short enough that the moment doesn't outstay its welcome.
  particleBurstMs: 1400,
  // Pack rising into frame on "Trade Proposed" — spring-ish, so it overshoots.
  packRevealMs: 900,
  // One pass of a trade-match line drawing itself between two map pins.
  matchLineDrawMs: 1200,
  // Trades nav icon acknowledging a new match. Fires once, never idles.
  tradeWobbleMs: 700,
  // Aura ring breathing under an opportunity pin.
  auraPulseMs: 2400,

  // ── Match trail entrance ─────────────────────────────────────────────────
  // One deliberate camera move that frames the origin and its destinations.
  // Never pin-to-pin flying: a single fit, then the trails draw into it.
  matchFrameMs: 700,
  // Gap between consecutive trails starting. Below ~160 they read as one event
  // firing twice; above ~220 the cascade starts to feel like a queue.
  matchTrailStaggerMs: 180,
  // Expanding ring when a trail reaches its destination.
  matchArrivalFlareMs: 320,
  // The mystery card's flight between the map beacon and the deck slot (and
  // back out into the reveal). Transform + opacity only — never layout.
  matchDockFlightMs: 520,
  // Card tilt/settle when the deck hands selection to another match.
  matchSwipeMs: 320,

  // ── Collector map ────────────────────────────────────────────────────────
  // Finger-down acknowledgement on a marker. Shorter than the global pressMs
  // because a map marker is small and the feedback has to land before the
  // finger lifts, not after.
  markerPressMs: 120,
  // Marker growing into its selected state (and the previous one letting go).
  markerSelectMs: 180,
  // Map utilities sliding out of the way when the preview sheet opens. Slower
  // than the marker so chrome reads as reacting to the selection, not racing
  // it. The sheet itself reuses `sheetSlideMs` — one sheet timing app-wide.
  utilityShiftMs: 220,
  // One deliberate camera move back to the user. Long enough that the map
  // stays legible while it travels, so the move teaches where "you" is.
  recenterCameraMs: 560,
};

export const MOTION_EASING = {
  standard: "cubic-bezier(0.4, 0, 0.2, 1)",
  decelerate: "cubic-bezier(0, 0, 0.2, 1)",
};
